import { createAsyncThunk } from "@reduxjs/toolkit";
import { NavigationLinksService } from "../../services/ux/navigation";

export const NavigationThunk = createAsyncThunk(
  "ux/navigation",
  async () => await (await NavigationLinksService.get())?.parsedBody?.navigationLinks
);
